exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".redaction-search-results-page-number{display:flex;align-items:center;margin-left:11px}.redaction-search-results-page-number label{font-size:13px;color:var(--faded-text)}", ""]);

// exports
